import './GenerateBillQRCode.css';
import QRCode from "qrcode.react";
import DateTimePicker from 'react-datetime-picker'
import React, {useState, useEffect} from "react";

const INITIAL_STATE = {
    cc: '310',
    vl: '',
    bn: '',
    si: '',
    po: '',
    un: '',
    co: 'SRB',
    ct: '',
    st: '000',
    uid: '',
    billString: '',
};

const inputFieldsNames = {
    cc: 'cc',
    vl: 'vl',
    bn: 'bn',
    si: 'si',
    po: 'po',
    un: 'un',
    co: 'co',
    ct: 'ct',
    st: 'st',
};

const INITIAL_DATE = new Date()

const INITIAL_BILL_STATE = ""

export const GenerateBillQRCode = () => {
    const [errors, setErrors] = useState({});
    const [values, setValues] = useState(INITIAL_STATE);
    const [dateTime, setDateTime] = useState(INITIAL_DATE);
    const [billString, setBillString] = useState(INITIAL_BILL_STATE);

    useEffect(() => {
        formatBillJsonAndSetValue()
    }, [values, dateTime, billString]);

    const handleChange = (event) => {
        setValues({...values, [event.target.name]: event.target.value});
    };

    const handleDateTimeChange = (event) => {
        setDateTime(event)
    }

    const handleBlur = () => {
        const validationErrors = validateInputField(values);
        setErrors(validationErrors);
    };

    const formatBillJsonAndSetValue = () => {
        const validationErrors = validateInputField(values);
        const noErrors = Object.keys(validationErrors).length === 0;
        if (noErrors) {
            const unixTimestamp = (dateTime.getTime() / 1000).toFixed(0);
            let billJsonString = "{" +
                `    cc: '${values.cc}',` +
                `    vl: ${values.vl},` +
                `    bn: ${values.bn},` +
                `    ut: ${unixTimestamp},` +
                `    si: '${values.si}',` +
                `    po: '${values.po}',` +
                `    un: '${values.un}',` +
                `    co: '${values.co}',` +
                `    ct: '${values.ct}',` +
                `    st: '${values.st}'` +
                "}"
            setBillString(billJsonString)
        } else {
            setBillString( "")
        }
    }

    const handleUidChange = (event) => {
        setValues({...values, [event.target.name]: event.target.value});
    };

    const validateInputField = (values) => {
        let errors = {};
        const valuesPropertyName = Object.keys(values);
        valuesPropertyName.forEach(propName => {
            switch (propName) {
                case inputFieldsNames.vl: {
                    if (!values.vl) {
                        errors.vl = 'Required';
                    } else if (isNaN(values.vl)) {
                        errors.vl = 'Invalid value';
                    }
                    break;
                }
                case inputFieldsNames.cc: {
                    if (!values.cc) {
                        errors.cc = 'Required';
                    }
                    break;
                }
                case inputFieldsNames.bn: {
                    if (!values.bn) {
                        errors.bn = 'Required';
                    }
                    break;
                }
                case inputFieldsNames.si: {
                    if (!values.si) {
                        errors.si = 'Required';
                    }
                    break;
                }
                case inputFieldsNames.po: {
                    if (!values.po) {
                        errors.po = 'Required';
                    }
                    break;
                }
                case inputFieldsNames.un: {
                    if (!values.un) {
                        errors.un = 'Required';
                    }
                    break;
                }
                case inputFieldsNames.co: {
                    if (!values.co) {
                        errors.co = 'Required';
                    }
                    break;
                }
                case inputFieldsNames.ct: {
                    if (!values.ct) {
                        errors.ct = 'Required';
                    }
                    break;
                }
                case inputFieldsNames.st: {
                    if (!values.st) {
                        errors.st = 'Required';
                    }
                    break;
                }
                default: {
                }
            }
        });
        return errors;
    };

    return (
        <div className='create-campaigns-layout'>
            <div className='generatebill-container'>
                <div className='generatebill-wrapper'>
                    <div className='generatebill-form-wrapper'>
                        <form className='generatebill-form'>
                            <div className='generatebill-form-section'>
                                <label className='generatebill-form-label'>
                                    User ID:
                                </label><br/>
                                <input className='generatebill-form-input' type="text" name='uid' value={values.uid}
                                       onBlur={handleBlur}
                                       onChange={handleUidChange}/>
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <label className='generatebill-form-label-header'>
                                    <h3>Bill Data:</h3>
                                </label>
                                <hr/>
                                <p className={'error-message'}>{errors.cc}</p>
                                <label className='generatebill-form-label'>
                                    Company (cc):
                                </label>
                                <input className='generatebill-form-input' type="text" name='cc' value={values.cc}
                                       onBlur={handleBlur}
                                       onChange={handleChange}/>
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <p className={'error-message'}>{errors.vl}</p>
                                <label className='generatebill-form-label'>
                                    Bill value (vl):
                                </label>
                                <input className='generatebill-form-input' type="text" name='vl' value={values.vl}
                                       onBlur={handleBlur}
                                       onChange={handleChange}/>
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <p className={'error-message'}>{errors.bn}</p>
                                <label className='generatebill-form-label'>
                                    Bill number (bn):
                                </label>
                                <input className='generatebill-form-input' type="text" name='bn' value={values.bn}
                                       onBlur={handleBlur}
                                       onChange={handleChange}/>
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <label className='generatebill-form-label'>
                                    Time (ut):
                                </label>
                                <DateTimePicker
                                    className='generatebill-form-input'
                                    format='dd.MM.y HH:mm:ss'
                                    onChange={handleDateTimeChange}
                                    name='ut'
                                    value={dateTime}
                                />
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <p className={'error-message'}>{errors.si}</p>
                                <label className='generatebill-form-label'>
                                    Store id (si):
                                </label>
                                <input className='generatebill-form-input' type="text" name='si' value={values.si}
                                       onBlur={handleBlur}
                                       onChange={handleChange}/>
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <p className={'error-message'}>{errors.po}</p>
                                <label className='generatebill-form-label'>
                                    POS id (po):
                                </label>
                                <input className='generatebill-form-input' type="text" name='po' value={values.po}
                                       onBlur={handleBlur}
                                       onChange={handleChange}/>
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <p className={'error-message'}>{errors.un}</p>
                                <label className='generatebill-form-label'>
                                    POS User id (un):
                                </label>
                                <input className='generatebill-form-input' type="text" name='un' value={values.un}
                                       onBlur={handleBlur}
                                       onChange={handleChange}/>
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <p className={'error-message'}>{errors.co}</p>
                                <label className='generatebill-form-label'>
                                    Country (co):
                                </label>
                                <input className='generatebill-form-input' type="text" name='co' value={values.co}
                                       onBlur={handleBlur}
                                       onChange={handleChange}/>
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <p className={'error-message'}>{errors.ct}</p>
                                <label className='generatebill-form-label'>
                                    City zip (ct):
                                </label>
                                <input className='generatebill-form-input' type="text" name='ct' value={values.ct}
                                       onBlur={handleBlur}
                                       onChange={handleChange}/>
                                <br/>
                            </div>
                            <div className='generatebill-form-section'>
                                <p className={'error-message'}>{errors.st}</p>
                                <label className='generatebill-form-label'>
                                    Status (st):
                                </label>
                                <input className='generatebill-form-input' type="text" name='st' value={values.st}
                                       onBlur={handleBlur}
                                       onChange={handleChange}/>
                                <br/>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className='generatebill-qr-layout'>
                <div className='generatebill-qr-wrapper'>
                    <label>
                        Bill Number QR Code: {billString}
                    </label><br/>
                    <QRCode hidden={billString.length === 0} size={256} includeMargin={true} value={billString}/>
                </div>
                <div className='generatebill-uid-qr-wrapper'>
                    <label className='go-right'>
                        User QR code:
                    </label><br/><br/>
                    <QRCode hidden={values.uid.length === 0} className='go-right' size={256} includeMargin={true}
                            value={values.uid}/>
                </div>
            </div>
        </div>

    )
}